import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Container, Button } from 'react-bootstrap';
import Loader from '../elements/Loader';
import { getExpiry } from '../../lib/utils';
import { fetchAPIToken, generateAPIToken } from '../../modules/automation';
import { useParams } from 'react-router-dom';
import { useNotification } from '../../hooks/NotificationContext';

const AutomationCredentials = () => {
  const [apiToken, setAPIToken] = useState(null);
  const [error, setError] = useState(null);
  const { addNotification } = useNotification();
  const [generatingToken, setGeneratingToken] = useState(false);
  const { projectId } = useParams();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const getExistingToken = async () => {
    try {
      setLoading(true);
      const response = await fetchAPIToken(projectId);
      setAPIToken(response?.body || null);
      setData(response);
      setLoading(false);
    } catch (error) {
      setError(error.message || 'Failed to fetch API token');
    }
  };

  const generateNewToken = async () => {
    setGeneratingToken(true);
    try {
      const response = await generateAPIToken(projectId)
      setAPIToken(response || null);
      addNotification('success', 'API token generated successfully!');
    } catch (error) {
      addNotification('danger', 'Unable to generate API token');
    }
    setGeneratingToken(false);
  };

  useEffect(() => {
    getExistingToken();
  }, [projectId]);

  const handleCopy = () => {
    navigator.clipboard
      .writeText(apiToken)
      .then(() => {
        addNotification('success', 'Copied API token!');
      })
      .catch((err) => {
        addNotification('danger', 'Failed to copy token!');
      });
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <Container fluid className="px-0">
      <Row>
        <Col>
          <h5>GAINSS API Token</h5>
          <p>
            This token can be used to access our public APIs. This token
            will be valid for 90 days. You can generate a new token at any
            time.
          </p>
          <Button
            className="mt-2"
            onClick={generateNewToken}
            disabled={generatingToken}>
            {generatingToken
              ? 'Generating...'
              : 'Generate GAINSS API Token'}
          </Button>
          {error && <p className="text-danger">{error}</p>}
        </Col>
      </Row>
      {!generatingToken && apiToken && (
        <Row className="mt-4">
          <Col md="12">
            <Form.Group>
              <Form.Label>
                Your API Token{' '}
                <span className="text-danger">
                  {' '}
                  {getExpiry(data?.created_at, data?.expires_in) ? `(Expired)` : ''}
                </span>
              </Form.Label>
              <Button
                variant="link"
                className="mb-1 btn-sm"
                style={{ float: 'right', textDecoration: 'none' }}
                onClick={handleCopy}>
                Click To Copy
              </Button>
              <Form.Control
                as="textarea"
                rows={3}
                readOnly
                value={apiToken}
              />
            </Form.Group>
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default AutomationCredentials;
